import { HashRouter } from "react-router-dom"
import { Layout } from "./components/Layout"
import { ConfigProvider } from 'antd';
import { SurveyProvider } from "./context/SurveyContext";
import ScrollToTop from "./components/ScrollToTop";

import './assets/scss/main.scss';

const App = () => {

  return (
    <SurveyProvider>
    <HashRouter>
      <ConfigProvider
      >
        <ScrollToTop />
        <Layout />
      </ConfigProvider>
    </HashRouter>
    </SurveyProvider>
  )
}

export default App
